var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-resize-observer", { on: { resize: _vm.onContainerResize } }, [
    _c(
      "div",
      {
        ref: "scrollable",
        staticClass: "base-virtual-scroll",
        on: { scroll: _vm.onScroll },
      },
      [
        _c("base-virtual-scroll-viewport", {
          attrs: {
            "data-key": _vm.dataKey,
            "visible-items": _vm.visibleItems,
            "is-loading": _vm.isLoading,
            "is-header-visible": _vm.isHeaderVisible,
            "is-footer-visible": _vm.isFooterVisible,
            "offset-top-px": _vm.offsetTopPx,
            "offset-bottom-px": _vm.offsetBottomPx,
            "offset-top-items": _vm.offsetTopItems,
            "get-item-size": _vm.VS.getItemSize,
            "render-delay": _vm.renderDelay,
          },
          on: {
            "item-activation": _vm.onItemActivation,
            "item-deactivation": _vm.onItemDeactivation,
            "item-resize": _vm.onItemResize,
            "header-slot-resize": _vm.onHeaderSlotResize,
            "footer-slot-resize": _vm.onFooterSlotResize,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function (props) {
                  return [_vm._t("default", null, null, props)]
                },
              },
              {
                key: "placeholder",
                fn: function () {
                  return [_vm._t("placeholder")]
                },
                proxy: true,
              },
              {
                key: "header",
                fn: function () {
                  return [_vm._t("header")]
                },
                proxy: true,
              },
              {
                key: "footer",
                fn: function () {
                  return [_vm._t("footer")]
                },
                proxy: true,
              },
              {
                key: "loader",
                fn: function () {
                  return [_vm._t("loader")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }